/* eslint-disable no-template-curly-in-string */
import { companyNameById } from '../models/company-name-by-id'

export const getLanguage = (companyId, countryId) => `${countryId}-${companyNameById[companyId]}`.toLowerCase()
